import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import MCADataCollectionUI from './MCADataCollectionUI.js'

class MCADataCollectionSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // MCA collection from ScoreMe
      mcaErrorList: null,
      mcaSuccessMsg: null,
      mcaSubmitted: false,
      // download files
      downloadRequested: false,
      fileErrorList: null,
      //
      mcaReuploadErrorList: null,
      mcaReuploadSuccessMsg: null,
      mcaReuploadSubmitted: false,
      //
      mcaJsonUploadMode: false,
      mcaJsonUploadErrorList: [],
      mcaExcelUploadMode: false,
      mcaExcelUploadErrorList: []
    }
  }

  render() {
    return (
      <MCADataCollectionUI
        context={this.props.context}
        account={this.props.account}
        onRefreshClick={this.props.onRefreshClick}
        onCopyToClipboard={this.props.onCopyToClipboard}
        copyToClipboardText={this.props.copyToClipboardText}
        //
        mcaErrorList={this.state.mcaErrorList}
        mcaSuccessMsg={this.state.mcaSuccessMsg}
        mcaSubmitted={this.state.mcaSubmitted}
        onMCASubmit={this.onMCASubmit}
        setMCAErrorList={() => { }}
        mcaFileList={this.props.mcaFileList}
        //
        onDownloadFileClick={this.onDownloadFileClick}
        fileErrorList={this.state.fileErrorList}
        //
        mcaReuploadErrorList={this.state.mcaReuploadErrorList}
        mcaReuploadSuccessMsg={this.state.mcaReuploadSuccessMsg}
        mcaReuploadSubmitted={this.state.mcaReuploadSubmitted}
        onMCAReuploadClick={this.onMCAReuploadClick}
        //
        mcaJsonUploadMode={this.state.mcaJsonUploadMode}
        onMcaJsonUploadClick={() => { this.setState({ mcaJsonUploadMode: true }) }}
        onMcaJsonCancelUploadClick={() => { this.setState({ mcaJsonUploadMode: false }) }}
        onMcaJsonUpload={this.onMcaJsonUpload}
        mcaJsonUploadErrorList={this.state.mcaJsonUploadErrorList}
        //
        mcaExcelUploadMode={this.state.mcaExcelUploadMode}
        onMcaExcelUploadClick={() => { this.setState({ mcaExcelUploadMode: true }) }}
        onMcaExcelCancelUploadClick={() => { this.setState({ mcaExcelUploadMode: false }) }}
        onMcaExcelUpload={this.onMcaExcelUpload}
        mcaExcelUploadErrorList={this.state.mcaExcelUploadErrorList}
      />
    )
  }

  componentDidMount = () => {
    let context = this.props.context
  }

  onMCASubmit = () => {
    let mcaSubmitted = this.state.mcaSubmitted
    if (mcaSubmitted)
      return

    this.setState({
      mcaSuccessMsg: null,
      mcaErrorList: [],
      mcaSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/mca/request`,
      this.onMCASubmitCallback, {}
    )
  }

  onMCASubmitCallback = (response) => {
    let mcaErrorList = []
    response.errorList.forEach(error => {
      mcaErrorList.push(error.message)
    })

    this.setState({
      mcaSuccessMsg: response.success,
      mcaErrorList: mcaErrorList,
      mcaSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ mcaSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ mcaErrorList: [] })
      }, 5000)
    }
  }

  setMCAErrorList = (mcaErrorList) => {
    this.setState({ mcaErrorList: mcaErrorList })
  }

  onDownloadFileClick = (event) => {
    let fileType = event.currentTarget.getAttribute('data-type')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/companyReports/files/${fileType}/${fileName}/fileDownloadSignedUrl`,
      this.onDownloadFileClickCallback, null, null
    )
  }

  onDownloadFileClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      // const link = document.createElement('a')
      // link.href = response.signedUrl.signedUrl
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      window.open(response.signedUrl.signedUrl, '_blank')
    }
  }

  onMCAReuploadClick = () => {
    let mcaReuploadSubmitted = this.state.mcaReuploadSubmitted
    if (mcaReuploadSubmitted)
      return

    this.setState({
      mcaReuploadSuccessMsg: null,
      mcaReuploadErrorList: [],
      mcaReuploadSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/scoreMe/MCA/scoreParameters`,
      this.onMCAReuploadClickCallback, {}
    )
  }

  onMCAReuploadClickCallback = (response) => {
    let mcaReuploadErrorList = []
    response.errorList.forEach(error => {
      mcaReuploadErrorList.push(error.message)
    })

    this.setState({
      mcaReuploadSuccessMsg: response.success,
      mcaReuploadErrorList: mcaReuploadErrorList,
      mcaReuploadSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ mcaReuploadSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ mcaReuploadErrorList: [] })
      }, 5000)
    }
  }

  onMcaJsonUpload = (fileId, fileName, fileType, fileSize) => {
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/mca/report/json/validation`,
      this.onMcaJsonUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onMcaJsonUploadCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      mcaJsonUploadErrorList: errorList,
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onMcaExcelUpload = (fileId, fileName, fileType, fileSize) => {
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/mca/report/excel/validation`,
      this.onMcaExcelUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onMcaExcelUploadCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      mcaExcelUploadErrorList: errorList,
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

}

export default MCADataCollectionSF
